var locale = {
  placeholder: '時刻を選択'
};
export default locale;
//# sourceMappingURL=ja_JP.js.map
